import { getDictPhrase } from "../../../common";
export const getBetTitleSystemBetProps = (bet, state) => {
    return {
        name: getDictPhrase(state.dict, bet.type) + (bet.isEachWay
            ? ` ${getDictPhrase(state.dict, "EachWay")}`
            : "")
    };
};
//# sourceMappingURL=getBetTitleSystemBetProps.js.map